import { Table } from "@/features/Table";
import { type StrategyVersion, strategy_versions_columns } from "./columns";
import {
  type FilterStrategyVersionSchema,
  FilterStrategyVersion,
} from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "strategy_versions";

export const StrategyVersionsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;
  return (
    <Table<StrategyVersion, FilterStrategyVersionSchema>
      label="Strategy Versions"
      client={client}
      table_name={table_name}
      columns={strategy_versions_columns}
      filter={<FilterStrategyVersion />}
      disable_translations_request={true}
      columnVisibilityInit={{
        company_id: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
